import {Selection, root} from "./selection/index";

export default function(selector) {
  return typeof selector === "string"
      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
      : new Selection([selector == null ? [] : selector], root);
}



//////////////////
// WEBPACK FOOTER
// /Users/ryan/Projects/texastribune/primary-early-vote-tracker-2018/node_modules/d3-selection/src/selectAll.js
// module id = null
// module chunks = 